import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      setModal, // via redux actions
      entity, // via parent component
      deleteEntity // via mutation
    } = props

    // perform GraphQL mutation
    const handleClickDelete = e => {
      e.preventDefault()
      deleteEntity({
        variables: {
          id: entity.id
        }
      })
    }

    // close the modal
    const handleClickCancel = e => {
      setModal({ open: false })
    }

    return (
      <WrappedComponent
        onClickCancel={handleClickCancel}
        onClickDelete={handleClickDelete}
        {...props}
      />
    )
  }
}

export default withEventHandlers
